const equipmentChangeStatusInput = {
  activeTitle: 'EQUIPO',
  activeTitleTrue: 'INACTIVAR',
  activeTitleFalse: 'REACTIVAR',
  maintenanceTitle: 'MANTENIMIENTO',
  maintenanceTitleTrue: 'REGRESAR DE',
  maintenanceTitleFalse: 'ENVIAR A',
};

export default equipmentChangeStatusInput;
